// 移植自姊妹專案 pixi_slot（FaFaCat 移植案）已驗證的 src/framework/net/PacketCodec.ts，
// 改用 proto/envelope.ts 的最小信封 schema（見該檔案註解），不依賴遊戲專屬 Protobuf 定義。
// 尚未接上本專案（Slot026）的真實後端，欄位版面未經本專案實機驗證。
//
// 封包外層編解碼 — 對應共用 Gateway PacketCmd（送出）/ ResponseInfo（回應）。
// 送出與回應的欄位佈局不同，分別處理。`data` 對本模組而言是不透明的 bytes——
// Slot026 專屬 Protobuf schema 尚未確認（見 docs/PROTOBUF_SCHEMA.md），故不在此處解析。
import { PacketCmdType, ResponseInfoType } from './proto/envelope'

export interface OutPacket {
  readonly cmd: string
  readonly requestId: string
  readonly data: Uint8Array
}

export interface ResponsePacket {
  readonly code: number
  readonly message: string
  readonly cmd: string
  readonly requestId: string
  readonly txnId: string
  readonly balance: bigint
  readonly currency: string
  readonly data: Uint8Array
  readonly totalWin: bigint
}

interface RawResponse {
  code?: number
  message?: string
  cmd?: string
  requestId?: string
  txnId?: string
  balance?: string
  currency?: string
  data?: Uint8Array
  totalWin?: string
}

export function encodePacket(packet: OutPacket): Uint8Array {
  const message = PacketCmdType.create({
    cmd: packet.cmd,
    requestId: packet.requestId,
    data: packet.data,
  })
  return PacketCmdType.encode(message).finish()
}

export function decodeResponse(bytes: Uint8Array): ResponsePacket {
  const raw = ResponseInfoType.toObject(ResponseInfoType.decode(bytes), {
    longs: String,
    bytes: Uint8Array,
    defaults: true,
  }) as RawResponse
  return {
    code: raw.code ?? 0,
    message: raw.message ?? '',
    cmd: raw.cmd ?? '',
    requestId: raw.requestId ?? '',
    txnId: raw.txnId ?? '',
    balance: BigInt(raw.balance ?? '0'),
    currency: raw.currency ?? '',
    data: raw.data ?? new Uint8Array(0),
    totalWin: BigInt(raw.totalWin ?? '0'),
  }
}
